/** Arabic for text inside the generated dashboard boards, applied by i18n/dom.ts (batch 2). Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "Filter by anything — a work order number, a stand, a crew, a fault":
    "صفِّ بأي شيء: رقم أمر عمل، موقف طائرة، فريق، عطل",
  WHAT: "ماذا",
  "Light unit failure": "عطل وحدة إنارة",
  RADAR: "رادار",
  "FOD / debris": "الأجسام الغريبة (FOD) / الحطام",
  "Ops response": "استجابة العمليات",
  "FOD control — Runway FOD walk": "مراقبة الأجسام الغريبة (FOD) — جولة FOD على المدرج",
  "Airside maintenance": "صيانة الجانب الجوي",
  "Sweeping — Runway swept": "الكنس — كنس المدرج",
  "Sweeping — Sweeper fleet available": "الكنس — توفر أسطول الكانسات",
  FLEET: "الأسطول",
  "Airfield ground lighting — Runway centreline circuit": "الإنارة الأرضية للمطار (AGL) — دائرة خط منتصف المدرج",
  "Airfield ground lighting — Runway edge circuit": "الإنارة الأرضية للمطار (AGL) — دائرة حافة المدرج",
  "Airfield ground lighting — Touchdown zone circuit": "الإنارة الأرضية للمطار (AGL) — دائرة منطقة ملامسة الأرض",
  "Airfield ground lighting — PAPI": "الإنارة الأرضية للمطار (AGL) — PAPI",
  "FOD control — Construction interface": "مراقبة الأجسام الغريبة (FOD) — واجهة أعمال الإنشاء",
  WORKS: "الأعمال",
  "Pavement defect": "عيب في الرصف",
  "Sign damage or legend": "تلف لوحة إرشادية أو كتابتها",
  "Vegetation control — Runway strip, grass height": "مكافحة النباتات — شريط المدرج، ارتفاع العشب",
  STRIP: "الشريط",
  "Spill contamination — Absorbent and granule stock": "تلوث الانسكاب — مخزون المواد الماصة والحبيبات",
  STORE: "المخازن",
  "Vegetation control — Around the navaids": "مكافحة النباتات — حول المساعدات الملاحية",
  "Spill contamination — Interceptor and drainage": "تلوث الانسكاب — المصيدة والتصريف",
  DRAIN: "التصريف",
  "Markings — Holding position markings": "العلامات الأرضية — علامات موقع الانتظار",
  "Airfield ground lighting — Photometric survey": "الإنارة الأرضية للمطار (AGL) — المسح الضوئي",
  "FOD control — Taxiway inspection": "مراقبة الأجسام الغريبة (FOD) — فحص ممرات الطائرات",
  "FOD control — Apron and stands": "مراقبة الأجسام الغريبة (FOD) — ساحة وقوف الطائرات والمواقف",
  APRON: "ساحة وقوف الطائرات",
  "Sweeping — Taxiways swept": "الكنس — كنس ممرات الطائرات",
  "Sweeping — Apron swept": "الكنس — كنس ساحة وقوف الطائرات",
  "FOD control — FOD bins serviceable": "مراقبة الأجسام الغريبة (FOD) — صلاحية حاويات FOD",
  "Marking repaint": "إعادة طلاء العلامات",
  "Airfield ground lighting — Taxiway centreline and edge":
    "الإنارة الأرضية للمطار (AGL) — خط منتصف ممر الطائرات وحافته",
  "Spill contamination — Response time, last event": "تلوث الانسكاب — زمن الاستجابة، آخر حدث",
  "Spill contamination — Residual staining and grip": "تلوث الانسكاب — البقع المتبقية والاحتكاك",
  "Airfield ground lighting — Stop bars and lead-on lights":
    "الإنارة الأرضية للمطار (AGL) — قضبان التوقف وأضواء الدخول",
  "Vegetation control — RESA and cleared areas": "مكافحة النباتات — RESA والمناطق المُخلاة",
  "Sweeping — Brush wear": "الكنس — تآكل الفرش",
  "Cable / circuit fault": "عطل كابل / دائرة",
  "Vegetation control — Perimeter fence line": "مكافحة النباتات — خط السياج المحيطي",
  FENCE: "السياج",
  "Spill contamination — Spill kits at the stands": "تلوث الانسكاب — حقائب الانسكاب عند المواقف",
  Anemometer: "مقياس سرعة الرياح",
  "Vegetation control — Drainage channels": "مكافحة النباتات — قنوات التصريف",
  "Runways and taxiways — Runway shoulders": "المدارج وممرات الطائرات — أكتاف المدرج",
  "Runways and taxiways — Taxiway surfaces": "المدارج وممرات الطائرات — أسطح ممرات الطائرات",
  "Runways and taxiways — Apron and stands": "المدارج وممرات الطائرات — ساحة وقوف الطائرات والمواقف",
  "Runways and taxiways — Surface drainage": "المدارج وممرات الطائرات — تصريف الأسطح",
  "Markings — Stand lead-in and stop bars": "العلامات الأرضية — خطوط الدخول إلى الموقف وقضبان التوقف",
  "Runways and taxiways — Joints and sealant": "المدارج وممرات الطائرات — الفواصل ومواد الإحكام",
  "Markings — Threshold and designators": "العلامات الأرضية — العتبة والمعرّفات",
  "Markings — Taxiway centreline": "العلامات الأرضية — خط منتصف ممر الطائرات",
  "Markings — Touchdown zone": "العلامات الأرضية — منطقة ملامسة الأرض",
  "Power supply and backup — daily check": "إمداد الطاقة والاحتياطي — فحص يومي",
  "critical utilities": "المرافق الحرجة",
  "Maintenance department": "إدارة الصيانة",
  "Fuel farm and hydrant system — daily check": "مستودع الوقود وشبكة الإمداد — فحص يومي",
  "Cooling and HVAC — daily check": "التبريد والتكييف — فحص يومي",
  "Water and sewage — daily check": "المياه والصرف الصحي — فحص يومي",
  "IT network and cyber security — daily check": "شبكة تقنية المعلومات والأمن السيبراني — فحص يومي",
  "Fire detection and suppression — daily check": "كشف الحريق وإطفاؤه — فحص يومي",
  "AODB and RMS — airport operations core — daily check": "AODB وRMS — أساس عمليات المطار — فحص يومي",
  "Power supply and IT network backbone — daily check": "إمداد الطاقة والشبكة الأساسية لتقنية المعلومات — فحص يومي",
  "CUPPS and CUTE — common use check-in and boarding — daily check":
    "CUPPS وCUTE — التسجيل والصعود المشترك الاستخدام — فحص يومي",
  "Baggage handling system — daily check": "نظام مناولة الأمتعة — فحص يومي",
  "Hold baggage screening — daily check": "فحص الأمتعة المسجلة — فحص يومي",
  "Security screening systems — daily check": "أنظمة التفتيش الأمني — فحص يومي",
  "Access control and CCTV — daily check": "التحكم في الدخول وCCTV — فحص يومي",
  expected: "المتوقع",
  "BHS maintenance": "صيانة BHS",
  "Transfer line — Tracking and misalignment": "خط التحويل — المسار وعدم الاستقامة",
  "Sorter — Tracking and misalignment": "جهاز الفرز — المسار وعدم الاستقامة",
  "Markings — Runway edge": "العلامات الأرضية — حافة المدرج",
  "how the work is going, what keeps breaking, and the archive": "كيف يسير العمل، وما يتعطل مرارًا، والأرشيف",
  "PRINT THE REPORT": "اطبع التقرير",
  "Raised against closed": "المفتوح مقابل المغلق",
  "Age of the open work": "عمر الأعمال المفتوحة",
  "Fault history — what keeps breaking": "سجل الأعطال — ما يتعطل مرارًا",
  "Ranked by count with the running share. Two or three types usually carry most of the work, and those are the ones worth engineering out rather than repairing again.":
    "مرتبة حسب العدد مع النسبة التراكمية. نوعان أو ثلاثة أنواع تحمل عادةً معظم العمل، وهي التي تستحق حلًا هندسيًا بدل إصلاحها مرة أخرى.",
  SHARE: "النسبة",
  "Counts, not performance. A crew with more open work may have more work, harder work, or fewer people — this says which, only that it is there.":
    "أعداد لا أداء. الفريق الذي لديه أعمال مفتوحة أكثر قد يكون لديه عمل أكثر أو أصعب أو أفراد أقل — هذا لا يحدد أيها، بل يبين أنها موجودة فقط.",
  "Record quality": "جودة السجلات",
  "Closed with a closing note": "مغلق بملاحظة إغلاق",
  "Carrying a position": "يحمل موقعًا",
  "Appears on the drawing or a floor plan.": "يظهر على المخطط أو على مخطط الطابق.",
  "movement, capacity and the ground": "الحركة والسعة والأرض",
  "live indicators": "مؤشرات مباشرة",
  "Emergency response": "الاستجابة للطوارئ",
  "VIP and royal movements": "حركة كبار الشخصيات والوفود الملكية",
  "Flight delays and cancellations": "تأخير الرحلات وإلغاؤها",
  "delay and cancellation counts awaiting feed": "أعداد التأخير والإلغاء بانتظار البيانات",
  "Delay and cancellation counts come from the AODB. Open work on stands, bridges, baggage and power is already held here, which is the part of the picture the airport owns.":
    "أعداد التأخير والإلغاء تأتي من AODB. الأعمال المفتوحة على المواقف والجسور والأمتعة والطاقة مسجلة هنا، وهي الجزء الذي يملكه المطار من الصورة.",
  "Rescue and fire fighting readiness": "جاهزية الإنقاذ ومكافحة الحريق",
  "category and vehicle status awaiting feed": "الفئة وحالة المركبات بانتظار البيانات",
  "Category, vehicle availability, media and crewing come from the RFF watch room. What is held here is the two fire stations on the register and anything raised against them.":
    "الفئة وتوفر المركبات والمواد والطواقم تأتي من غرفة مراقبة RFF. المسجل هنا هو محطتا الإطفاء في السجل وأي شيء فُتح عليهما.",
  "Ground operations status": "حالة العمليات الأرضية",
  "Air traffic volume": "حجم الحركة الجوية",
  "Awaiting feed": "بانتظار البيانات",
  "Stand availability": "توفر المواقف",
  "Cargo movement and storage": "حركة الشحن والتخزين",
  "tonnage and storage awaiting feed": "الحمولة والتخزين بانتظار البيانات",
  "Tonnage, dwell and warehouse occupancy come from the cargo terminal system. Work orders raised against the cargo terminal or its stores are already held here.":
    "الحمولة ومدة البقاء وإشغال المستودعات تأتي من نظام مبنى الشحن. أوامر العمل المفتوحة على مبنى الشحن أو مخازنه مسجلة هنا.",
  "Ground handling performance": "أداء الخدمات الأرضية",
  "turnaround performance awaiting feed": "أداء خدمة الطائرة بانتظار البيانات",
  "Turnaround performance comes from the handling agents. What this system already knows is the ground they work on — stands held by maintenance, bridges out of service and open apron work all turn into turnaround minutes.":
    "أداء خدمة الطائرة بين الرحلات يأتي من وكلاء الخدمات الأرضية. ما يعرفه هذا النظام هو الأرض التي يعملون عليها — المواقف المحجوزة للصيانة والجسور خارج الخدمة وأعمال الساحة المفتوحة كلها تتحول إلى دقائق في خدمة الطائرة.",
  "Aircraft turnaround": "خدمة الطائرة بين الرحلات",
  "turnaround milestones awaiting feed": "مراحل خدمة الطائرة بانتظار البيانات",
  "Turnaround milestones come from A-CDM or the handling system. Bridge and stand work raised here is already counted.":
    "مراحل خدمة الطائرة تأتي من A-CDM أو نظام الخدمات الأرضية. أعمال الجسور والمواقف المفتوحة هنا محسوبة.",
  "unit status awaiting feed": "حالة الوحدات بانتظار البيانات",
  "Docking guidance status comes from the A-VDGS or the stand equipment log. A unit out means marshalling, which costs minutes on every arrival to that stand.":
    "حالة توجيه الالتحام تأتي من A-VDGS أو سجل معدات الموقف. تعطل وحدة يعني التوجيه اليدوي، وهذا يكلف دقائق في كل وصول إلى ذلك الموقف.",
  "Passenger boarding bridges": "جسور صعود الركاب",
  "availability awaiting feed": "التوفر بانتظار البيانات",
  "Bridge availability and docking times come from the PBB control system. Work orders raised against a bridge are counted here already.":
    "توفر الجسور وأزمنة الالتحام تأتي من نظام التحكم في PBB. أوامر العمل المفتوحة على جسر محسوبة هنا.",
  "Operational resilience": "المرونة التشغيلية",
  "Resilience grade": "تقدير المرونة",
  "nothing measured yet": "لم يُقس شيء بعد",
  "Exercises, three years": "التمارين، ثلاث سنوات",
  "Backup systems": "الأنظمة الاحتياطية",
  "Weather delay today": "تأخير الطقس اليوم",
  "disruption feed": "بيانات الاضطرابات",
  "Since the last full exercise": "منذ آخر تمرين شامل",
  "exercise record": "سجل التمارين",
  "Since any exercise": "منذ أي تمرين",
  "Continuity plans current": "خطط الاستمرارية سارية",
  "continuity office": "مكتب الاستمرارية",
  "Continuity plans tested": "خطط الاستمرارية مختبرة",
  "Recovery time objectives met": "تحقق أهداف زمن الاستعادة",
  "last continuity test": "آخر اختبار استمرارية",
  "Single points of failure": "نقاط الإخفاق المنفردة",
  "continuity register": "سجل الاستمرارية",
  "Backup systems ready": "الأنظمة الاحتياطية جاهزة",
  "power, comms and data feeds": "الطاقة والاتصالات ومصادر البيانات",
  "Since the last generator test": "منذ آخر اختبار للمولد",
  "generator test log": "سجل اختبار المولدات",
  "Crisis team trained": "فريق الأزمات مدرّب",
  "crisis team records": "سجلات فريق الأزمات",
  "Since the call-out test": "منذ اختبار الاستدعاء",
  "call-out test record": "سجل اختبار الاستدعاء",
  "Incident reports · operations": "تقارير الحوادث · العمليات",
  "Checkpoint screening (TSA)": "التفتيش الأمني (TSA)",
  "queue and lane status awaiting feed": "حالة الطوابير والمسارات بانتظار البيانات",
  "Lane status, queue times and throughput come from the queue measurement system or the screening authority. Work raised here against screening equipment is already counted.":
    "حالة المسارات وأزمنة الانتظار والإنتاجية تأتي من نظام قياس الطوابير أو جهة التفتيش. الأعمال المفتوحة هنا على معدات التفتيش محسوبة.",
  "Lifts, escalators and travelators": "المصاعد والسلالم والممرات المتحركة",
  "Gate crowding": "الازدحام عند البوابات",
  "hold room occupancy awaiting feed": "إشغال صالات الانتظار بانتظار البيانات",
  "Hold room occupancy comes from the gate counting system. Work orders raised against a gate or its seating are already held here.":
    "إشغال صالات الانتظار يأتي من نظام العد عند البوابات. أوامر العمل المفتوحة على بوابة أو مقاعدها مسجلة هنا.",
  "Seating availability": "توفر المقاعد",
  "seat inventory awaiting feed": "مخزون المقاعد بانتظار البيانات",
  "Seat inventory against occupancy. The installed count is an asset figure — it belongs in the register and changes only when seating is added, removed or taken out of service.":
    "مخزون المقاعد مقابل الإشغال. العدد المركّب رقم أصول — مكانه السجل ولا يتغير إلا عند إضافة مقاعد أو إزالتها أو إخراجها من الخدمة.",
  "Kerbside and airport entrances": "الأرصفة ومداخل المطار",
  "kerb occupancy and entrance queues awaiting feed": "إشغال الأرصفة وطوابير المداخل بانتظار البيانات",
  "Kerb occupancy, dwell and entrance queues come from traffic counting or ANPR. Landside work orders on roads, signage and barriers are already held here.":
    "إشغال الأرصفة ومدة التوقف وطوابير المداخل تأتي من عدّ الحركة المرورية أو ANPR. أوامر العمل في الجانب الأرضي على الطرق واللوحات والحواجز مسجلة هنا.",
  "Queues and crowds": "الطوابير والازدحام",
  "awaiting counters": "بانتظار العدادات",
  "counting points awaiting feed": "نقاط العد بانتظار البيانات",
  "Queue counters come from people counting or the queue measurement system. Until one is connected these counters are assembled from the crowding, checkpoint and gate figures already on the dashboard.":
    "عدادات الطوابير تأتي من عدّ الأشخاص أو نظام قياس الطوابير. إلى أن يُربط أحدها، تُجمع هذه العدادات من أرقام الازدحام ونقاط التفتيش والبوابات الموجودة على لوحة المعلومات.",
  "Immigration queues": "طوابير الجوازات",
  "desk and eGate status awaiting feed": "حالة الكاونترات والبوابات الإلكترونية بانتظار البيانات",
  "Desk and eGate status comes from the immigration authority or the queue system. Work orders on eGates, kiosks and booth equipment are already held here.":
    "حالة الكاونترات والبوابات الإلكترونية تأتي من جهة الجوازات أو نظام الطوابير. أوامر العمل على البوابات الإلكترونية والأكشاك ومعدات الكبائن مسجلة هنا.",
  "Customs and border": "الجمارك والحدود",
  "channel status awaiting feed": "حالة المسارات بانتظار البيانات",
  "Channel status, clearance times and referral rates come from customs. Work orders on scanners and inspection equipment are already held here.":
    "حالة المسارات وأزمنة الفسح ونسب الإحالة تأتي من الجمارك. أوامر العمل على أجهزة الفحص ومعدات التفتيش مسجلة هنا.",
  "Terminal crowding": "الازدحام في مبنى الركاب",
  "Needs people counting or queue measurement. Until then terminal condition is judged by inspection alone.":
    "يحتاج إلى عدّ الأشخاص أو قياس الطوابير. حتى ذلك الحين تُقدَّر حالة مبنى الركاب بالفحص وحده.",
  "Terminal passenger flow": "تدفق الركاب في مبنى الركاب",
  "stage flow rates awaiting feed": "معدلات التدفق في المراحل بانتظار البيانات",
  "Flow rates through each stage of the journey come from people counting or the passenger numbers in the AODB. Until they do, terminal condition is judged by inspection and by the crowding tile alone.":
    "معدلات التدفق عبر كل مرحلة من الرحلة تأتي من عدّ الأشخاص أو أعداد الركاب في AODB. إلى أن يتوفر ذلك، تُقدَّر حالة مبنى الركاب بالفحص وبمربع الازدحام وحده.",
  "line status awaiting feed": "حالة الخطوط بانتظار البيانات",
  "Line status, on-time delivery and jam counts come from the BHS control system. Baggage work orders raised here are already counted.":
    "حالة الخطوط والتسليم في الوقت وأعداد الانحشار تأتي من نظام التحكم في BHS. أوامر عمل الأمتعة المفتوحة هنا محسوبة.",
  "Terminal temperature by zone": "درجة حرارة مبنى الركاب حسب المنطقة",
  "zone temperatures awaiting feed": "درجات حرارة المناطق بانتظار البيانات",
  "Zone temperatures come from the building management system. Open HVAC and chiller work is already held here.":
    "درجات حرارة المناطق تأتي من نظام إدارة المبنى. أعمال التكييف والمبردات المفتوحة مسجلة هنا.",
  "Passenger experience": "تجربة الركاب",
  "Experience grade": "تقدير التجربة",
  "Complaints by subject": "الشكاوى حسب الموضوع",
  "Satisfaction trend": "اتجاه الرضا",
  "Worst queue in the terminal": "أسوأ طابور في مبنى الركاب",
  "queue counters": "عدادات الطوابير",
  "Security screening queue": "طابور التفتيش الأمني",
  "checkpoint feed": "بيانات نقطة التفتيش",
  "Immigration queue": "طابور الجوازات",
  "immigration feed": "بيانات الجوازات",
  "Airline check-in counters open": "كاونترات تسجيل شركات الطيران المفتوحة",
  "airline check-in allocation": "توزيع كاونترات تسجيل شركات الطيران",
  "baggage handling feed": "بيانات مناولة الأمتعة",
  "First bag on the belt": "أول حقيبة على السير",
  "Terminal cleanliness score": "درجة نظافة مبنى الركاب",
  "cleaning audit": "تدقيق النظافة",
  "Washroom score": "درجة دورات المياه",
  "washroom survey": "استبيان دورات المياه",
  "Passenger complaints": "شكاوى الركاب",
  "complaints register": "سجل الشكاوى",
  "Complaints resolved in target": "شكاوى حُلّت ضمن المستهدف",
  "Assistance delivered on time": "المساعدة المقدمة في الوقت",
  "assistance provider": "مقدم المساعدة",
  "Customer satisfaction": "رضا العملاء",
  "passenger survey": "استبيان الركاب",
  "Incident reports · terminal": "تقارير الحوادث · مبنى الركاب",
  "airlines, handlers, contractors and the agencies": "شركات الطيران ومقدمو الخدمات الأرضية والمقاولون والجهات",
  "Stakeholder performance": "أداء الأطراف المعنية",
  "awaiting the partner and contract records": "بانتظار سجلات الشركاء والعقود",
  "Service levels, incidents and attendance come from the parties themselves and from the records held here. Nothing on this page is inferred.":
    "مستويات الخدمة والحوادث والحضور تأتي من الأطراف أنفسهم ومن السجلات المحفوظة هنا. لا شيء في هذه الصفحة مُستنتَج.",
  "Expected shape:": "الشكل المتوقع:",
  "what stops the airport": "ما يوقف المطار",
  "CCTV surveillance": "المراقبة بـCCTV",
  "camera and recorder status awaiting feed": "حالة الكاميرات والمسجلات بانتظار البيانات",
  online: "متصل",
  recording: "يسجّل",
  retained: "محفوظ",
  "down or degraded": "متعطل أو متدهور",
  "Camera status, recording state and retention come from the video management system. Work orders on cameras, recorders and their power are already held here.":
    "حالة الكاميرات والتسجيل ومدة الحفظ تأتي من نظام إدارة الفيديو. أوامر العمل على الكاميرات والمسجلات وتغذيتها بالطاقة مسجلة هنا.",
  "Cyber security threats": "تهديدات الأمن السيبراني",
  "posture awaiting feed from the security team": "الوضع الأمني بانتظار بيانات فريق الأمن",
  "Electrical systems": "الأنظمة الكهربائية",
  "Voltage, consumption and waveform come from the power monitoring system. Power plant, both AGL substations and the three LV substations scored from open work and findings against each.":
    "الجهد والاستهلاك وشكل الموجة تأتي من نظام مراقبة الطاقة. محطة الطاقة ومحطتا AGL الفرعيتان ومحطات LV الفرعية الثلاث مقيّمة من الأعمال المفتوحة والملاحظات على كل منها.",
  "Connect AWOS or the METAR feed for wind, visibility and temperature, and the crosswind split across all four runway directions is computed from the measured runway bearings.":
    "اربط AWOS أو بيانات METAR للرياح والرؤية ودرجة الحرارة، وتُحسب مركّبة الرياح المستعرضة لاتجاهات المدرج الأربعة من اتجاهات المدرج المقاسة.",
  "Precipitation radar": "رادار الهطول",
  "Cell positions, intensity and track come from the weather radar product. Nothing is drawn that the feed has not reported.":
    "مواقع الخلايا وشدتها ومسارها تأتي من منتج رادار الطقس. لا يُرسم شيء لم تُبلغ عنه البيانات.",
  "Regional disruption": "الاضطرابات الإقليمية",
  "Regional NOTAM and weather status. Diversions land here with little notice and are the fastest way to fill a stand list and a terminal.":
    "حالة NOTAM والطقس في المنطقة. الرحلات المحوّلة تهبط هنا دون إشعار كافٍ، وهي أسرع ما يملأ قائمة المواقف ومبنى الركاب.",
  "list awaiting feed": "القائمة بانتظار البيانات",
  "Incident reports · airside": "تقارير الحوادث · الجانب الجوي",
  "safety policy, risk, assurance and promotion": "سياسة السلامة والمخاطر والضمان والتعزيز",
  "Safety management system": "نظام إدارة السلامة",
  "FILE A SAFETY REPORT": "قدّم تقرير سلامة",
  ANALYSE: "حلّل",
  "SEND THE REPORT": "أرسل التقرير",
  "Safety policy and objectives": "سياسة السلامة وأهدافها",
  "Safety risk management": "إدارة مخاطر السلامة",
  "Safety assurance": "ضمان السلامة",
  "Safety promotion": "تعزيز السلامة",
  "Each component is scored from records held here. A component with nothing fed against it scores as unmeasured rather than as compliant — a system cannot be graded green for the absence of evidence.":
    "يُقيَّم كل مكوّن من السجلات المحفوظة هنا. المكوّن الذي لا تُغذّى له بيانات يُقيَّم غير مقاس لا ممتثلًا — لا يمكن منح نظام تقديرًا أخضر لغياب الأدلة.",
  "Press ANALYSE to read every entry on this page against the four components and return what it finds, with the reasoning shown.":
    "اضغط حلّل لقراءة كل إدخال في هذه الصفحة مقابل المكونات الأربعة وعرض ما يجده مع بيان الأسباب.",
  "Risk before controls": "المخاطرة قبل الضوابط",
  "How the matrix and its bands work": "كيف تعمل المصفوفة ونطاقاتها",
  "Risk after controls": "المخاطرة بعد الضوابط",
  "Safety performance indicators": "مؤشرات أداء السلامة",
  "Occurrence reports": "تقارير الوقائع",
  "Serious occurrences": "الوقائع الجسيمة",
  "Hazards without controls": "مخاطر بلا ضوابط",
  "Open safety actions": "إجراءات السلامة المفتوحة",
  "Audit findings open": "ملاحظات التدقيق المفتوحة",
  "Inspection findings open": "ملاحظات الفحص المفتوحة",
  "Hazard treatment": "معالجة المخاطر",
  "How policy and objectives are scored": "كيف تُقيَّم السياسة والأهداف",
  "SMS manual": "دليل SMS",
  "Safety policy signed by the accountable executive": "سياسة السلامة موقّعة من المسؤول التنفيذي",
  "Emergency plan": "خطة الطوارئ",
  "No runway incursions": "لا توجد توغلات في المدرج",
  "Occurrence reporting rate": "معدل الإبلاغ عن الوقائع",
  "not measured": "غير مقاس",
  "Hazards with controls in place": "مخاطر لها ضوابط مطبّقة",
  "Safety actions closed inside target": "إجراءات السلامة المغلقة ضمن المستهدف",
  "Safety training current": "تدريب السلامة ساري",
  "Full emergency exercise inside two years": "تمرين طوارئ شامل خلال سنتين",
  "How risk management is scored": "كيف تُقيَّم إدارة المخاطر",
  HAZARD: "الخطر",
  INITIAL: "المبدئية",
  RESIDUAL: "المتبقية",
  CONTROLS: "الضوابط",
  "Rubber accumulation reducing friction in the touchdown zones": "تراكم المطاط يقلل الاحتكاك في مناطق ملامسة الأرض",
  intolerable: "غير مقبولة",
  tolerable: "محتملة",
  "Quarterly friction survey; Removal at the planning level rather than the minimum; Verification survey after every removal":
    "مسح احتكاك ربع سنوي؛ الإزالة عند مستوى التخطيط لا الحد الأدنى؛ مسح تحقق بعد كل إزالة",
  controlled: "تحت السيطرة",
  "Runway incursion at the hold points during low visibility": "توغل في المدرج عند نقاط الانتظار أثناء انخفاض الرؤية",
  "Stop bars serviceable and used; Driver permit scheme; LVP procedures":
    "قضبان توقف صالحة ومستخدمة؛ نظام تصاريح القيادة؛ إجراءات LVP",
  "Foreign object debris from construction traffic": "أجسام غريبة من حركة مركبات الإنشاء",
  "Apron and taxiways · Apron expansion has increased vehicle movements through the eastern gate.":
    "ساحة وقوف الطائرات وممرات الطائرات · زادت توسعة الساحة حركة المركبات عبر البوابة الشرقية.",
  "Sweeping before and after each construction shift; FOD checks at every access gate":
    "الكنس قبل كل وردية إنشاء وبعدها؛ فحوص FOD عند كل بوابة دخول",
  "Lift and escalator brake failure in the terminal": "عطل فرامل المصاعد والسلالم المتحركة في مبنى الركاب",
  "Terminal · Raised from the failed statutory examination.": "مبنى الركاب · مرفوع من الفحص النظامي الذي لم يُجتز.",
  acceptable: "مقبولة",
  "Statutory examination; Two units withdrawn pending retest": "الفحص النظامي؛ سحب وحدتين بانتظار إعادة الاختبار",
  "Loss of standby power during a terminal outage": "فقدان الطاقة الاحتياطية أثناء انقطاع في مبنى الركاب",
  "Terminal and airfield · Generator testing interval has slipped past thirty days.":
    "مبنى الركاب والجانب الجوي · تجاوزت فترة اختبار المولدات ثلاثين يومًا.",
  "Monthly generator test; UPS on critical systems; Load bank test annually":
    "اختبار شهري للمولدات؛ UPS على الأنظمة الحرجة؛ اختبار حمل سنوي",
  "Baggage handling stoppage at peak": "توقف مناولة الأمتعة في وقت الذروة",
  "Fallback and recirculation proven; Manual sortation plan": "ثبوت نجاح البديل وإعادة التدوير؛ خطة فرز يدوي",
  "Wildlife strike on approach": "اصطدام بالحياة الفطرية أثناء الاقتراب",
  "Aerodrome and surrounds · Eleven strikes in twelve months against a target of eight; no habitat survey on file.":
    "المطار ومحيطه · أحد عشر اصطدامًا في اثني عشر شهرًا مقابل مستهدف ثمانية؛ لا يوجد مسح للموائل في الملف.",
  "Habitat management; Dispersal patrols": "إدارة الموائل؛ دوريات التنفير",
  identified: "محدَّد",
  "How assurance is measured": "كيف يُقاس الضمان",
  "Audits on record": "عمليات التدقيق المسجلة",
  "Incidents on the register": "الحوادث في السجل",
  "Reporting rate": "معدل الإبلاغ",
  "How promotion is measured": "كيف يُقاس التعزيز",
  "Risk assessments current": "تقييمات المخاطر سارية",
  "Confidential reporting used": "استخدام الإبلاغ السري",
  "Safety communications issued": "رسائل السلامة الصادرة",
  "Partners filing reports": "الشركاء الذين يقدمون تقارير",
  "not fed of the parties": "لم تُغذَّ من الأطراف",
  "What happens to a report once it is filed": "ماذا يحدث للتقرير بعد تقديمه",
  "Safety suggestion": "اقتراح سلامة",
  accepted: "مقبول",
  "Occurrence report": "تقرير واقعة",
  confidential: "سري",
  "Held short of the runway with the markings barely visible in the rain. I was not certain I was at the right hold point.":
    "توقفت قبل المدرج والعلامات بالكاد مرئية تحت المطر. لم أكن متأكدًا أنني عند نقطة الانتظار الصحيحة.",
  assessed: "مُقيَّم",
  "Hazard report": "تقرير خطر",
  "Ramp agent": "وكيل ساحة",
  "Ground power cable left across the walkway after departure. Someone will trip on it at night.":
    "كابل الطاقة الأرضية تُرك عبر الممشى بعد المغادرة. سيتعثر به أحد في الليل.",
  "under review": "قيد المراجعة",
  "Regulatory compliance": "الامتثال التنظيمي",
  "PRINT THE COMPLIANCE PACK": "اطبع حزمة الامتثال",
  "Security programme": "برنامج الأمن",
  "Safety management performance": "أداء إدارة السلامة",
  "Environmental compliance": "الامتثال البيئي",
  "Audit and inspection findings": "ملاحظات التدقيق والفحص",
  "Corrective action status": "حالة الإجراءات التصحيحية",
  verified: "تم التحقق",
  "Reference library": "المكتبة المرجعية",
  "UPDATE DOCUMENTS": "حدّث المستندات",
  "No text is reproduced here.": "لا يُعاد نشر أي نص هنا.",
  "IEC, ISO, EN, NFPA and national codes": "IEC وISO وEN وNFPA والأكواد الوطنية",
  Standards: "المعايير",
  "Operation and maintenance manuals": "أدلة التشغيل والصيانة",
  Manufacturer: "الشركة المصنّعة",
  "Drawings, surveys and facility records": "المخططات والمسوحات وسجلات المرافق",
  "Search a reference, a title, or what it governs": "ابحث عن مرجع أو عنوان أو ما ينظّمه",
  BODY: "الجهة",
  "WHAT IT GOVERNS": "ما ينظّمه",
  COPY: "النسخة",
  "Physical characteristics, obstacle limitation, visual aids, equipment and operational procedures for aerodromes.":
    "الخصائص الفيزيائية وحدود العوائق والمساعدات البصرية والمعدات والإجراءات التشغيلية للمطارات.",
  "Airfield · Inspections · Friction · Rubber · Compliance": "الجانب الجوي · الفحوص · الاحتكاك · المطاط · الامتثال",
  "NOT HELD": "غير متوفر",
  "Aerodrome emergency planning, rescue and fire fighting category, response times, removal of disabled aircraft.":
    "تخطيط الطوارئ في المطار، وفئة الإنقاذ ومكافحة الحريق، وأزمنة الاستجابة، وإزالة الطائرات المعطلة.",
  "Operational resilience · Compliance": "المرونة التشغيلية · الامتثال",
  "State safety programme and the safety management system an operator must run.":
    "برنامج السلامة الوطني ونظام إدارة السلامة الذي يجب أن يشغّله المشغّل.",
  "SMS · Compliance": "SMS · الامتثال",
  "Safeguarding international civil aviation against acts of unlawful interference.":
    "حماية الطيران المدني الدولي من أفعال التدخل غير المشروع.",
  "Safety critical · Compliance": "حرج للسلامة · الامتثال",
  "Aircraft noise, engine emissions and aerodrome environmental obligations.":
    "ضوضاء الطائرات وانبعاثات المحركات والالتزامات البيئية للمطار.",
  "Sustainability · Compliance": "الاستدامة · الامتثال",
  "Airfield · Inspections · Certification · Compliance · SMS": "الجانب الجوي · الفحوص · الاعتماد · الامتثال · SMS",
  "Physical characteristics, obstacle environment and visual aids for heliports.":
    "الخصائص الفيزيائية وبيئة العوائق والمساعدات البصرية لمهابط المروحيات.",
  "Airfield · Compliance": "الجانب الجوي · الامتثال",
  "Guidance on RFF category, agents, vehicles, staffing and response.":
    "إرشادات حول فئة RFF والمواد والمركبات والتوظيف والاستجابة.",
  "Friction measurement, reporting, contaminant assessment and surface condition.":
    "قياس الاحتكاك والإبلاغ عنه وتقييم الملوثات وحالة السطح.",
  "Friction · Rubber": "الاحتكاك · المطاط",
  "Maintenance of pavements, visual aids and the movement area.": "صيانة الرصف والمساعدات البصرية ومنطقة الحركة.",
  "Inspections · Engineering": "الفحوص · الهندسة",
  "Pavement design, evaluation, PCN reporting and condition survey method.":
    "تصميم الرصف وتقييمه والإبلاغ عن PCN وطريقة مسح الحالة.",
  "Assessments · Projects": "التقييمات · المشاريع",
  "Design of markings, lights, signs and markers.":
    "تصميم العلامات الأرضية والأضواء واللوحات الإرشادية والعلامات الدالة.",
  "Airfield · Assessments": "الجانب الجوي · التقييمات",
  "Contents of the aerodrome manual and the certification process.": "محتويات دليل المطار وإجراءات الاعتماد.",
  "Compliance · Documents": "الامتثال · المستندات",
  "Certification and operation of aerodromes in the Kingdom. The instrument this airport's certificate is held under.":
    "اعتماد المطارات وتشغيلها في المملكة. الأداة التنظيمية التي تصدر بموجبها شهادة هذا المطار.",
  "Compliance · Inspections · Documents": "الامتثال · الفحوص · المستندات",
  "National SMS requirements for certificate holders.": "متطلبات SMS الوطنية لحاملي الشهادات.",
  "Security measures, screening, restricted areas and access control.":
    "التدابير الأمنية والتفتيش والمناطق المقيدة والتحكم في الدخول.",
  "Friction levels, CFME devices, survey method and rubber removal triggers. The friction levels this platform reports against come from this family of guidance.":
    "مستويات الاحتكاك وأجهزة CFME وطريقة المسح ومحفزات إزالة المطاط. مستويات الاحتكاك التي تُبلغ عنها هذه المنصة مأخوذة من هذه المجموعة من الإرشادات.",
  "Friction · Rubber · Assessments": "الاحتكاك · المطاط · التقييمات",
  "Pavement maintenance, distress identification and repair method.": "صيانة الرصف وتحديد التلف وطريقة الإصلاح.",
  "Engineering · Projects": "الهندسة · المشاريع",
  "Assessments · Engineering · Inspections": "التقييمات · الهندسة · الفحوص",
  "Inspections · Safety critical · Airfield": "الفحوص · حرج للسلامة · الجانب الجوي",
  "Geometry, colour and application of movement area markings.":
    "الأبعاد والألوان وتطبيق العلامات الأرضية في منطقة الحركة.",
  "Airfield · Assessments · Projects": "الجانب الجوي · التقييمات · المشاريع",
  "Installation of airfield lighting, signs, circuits and regulators.":
    "تركيب الإنارة الأرضية للمطار واللوحات الإرشادية والدوائر ومنظمات التيار.",
  "Airfield · Projects · Assessments": "الجانب الجوي · المشاريع · التقييمات",
  "Self-inspection programme, frequency, checklists and recording.":
    "برنامج الفحص الذاتي وتكراره وقوائم التحقق والتسجيل.",
  "Construction specifications, material testing and acceptance criteria — the basis for the engineering inspection checkpoints in Projects.":
    "مواصفات الإنشاء واختبار المواد ومعايير القبول — أساس نقاط التحقق في الفحص الهندسي ضمن المشاريع.",
  "Projects · Assessments": "المشاريع · التقييمات",
  "Geometric design of runways, taxiways, aprons and separation distances.":
    "التصميم الهندسي للمدارج وممرات الطائرات وساحات وقوف الطائرات ومسافات الفصل.",
  "Airfield · Projects": "الجانب الجوي · المشاريع",
  "Water supply provision for RFF operations.": "توفير إمدادات المياه لعمليات RFF.",
  "Terminal capacity planning, level of service and facility sizing.":
    "تخطيط سعة مبنى الركاب ومستوى الخدمة وتحديد أحجام المرافق.",
  "Passenger experience · Sustainability · Projects": "تجربة الركاب · الاستدامة · المشاريع",
  "Programme requirements and guidance": "متطلبات البرنامج وإرشاداته",
  "Carbon mapping, reduction, optimisation and the levels used on the sustainability page.":
    "رسم خرائط الكربون وخفضه وتحسينه، والمستويات المستخدمة في صفحة الاستدامة.",
  "Low-voltage electrical installations": "التركيبات الكهربائية منخفضة الجهد",
  "Installation, inspection and testing of LV systems — the basis of the electrical inspection checkpoints.":
    "تركيب أنظمة LV وفحصها واختبارها — أساس نقاط التحقق في الفحص الكهربائي.",
  "Protection against lightning": "الحماية من الصواعق",
  "Lightning protection design and testing.": "تصميم الحماية من الصواعق واختبارها.",
  "Fire detection, notification and testing intervals.": "كشف الحريق والإنذار وفترات الاختبار.",
  "Assessments · Systems": "التقييمات · الأنظمة",
  "Generator classification, testing and load bank requirements.": "تصنيف المولدات واختبارها ومتطلبات اختبار الحمل.",
  "Operational resilience · Assessments": "المرونة التشغيلية · التقييمات",
  "Safety rules for the construction and examination of lifts and escalators.":
    "قواعد السلامة لإنشاء المصاعد والسلالم المتحركة وفحصها.",
  "Assessments · Passenger experience": "التقييمات · تجربة الركاب",
  "Condition monitoring — thermography": "مراقبة الحالة — التصوير الحراري",
  "Thermographic survey method and reporting.": "طريقة المسح الحراري والإبلاغ عنه.",
  "Aerodrome plan": "مخطط المطار",
  "Airfield · Plans": "الجانب الجوي · المخططات",
  "Friction · Assessments": "الاحتكاك · التقييمات",
  "Plans · Buildings": "المخططات · المباني",
  "MEP utilities drawing": "مخطط المرافق MEP",
  "Plans · Engineering": "المخططات · الهندسة",
  "O&M manuals": "أدلة O&M",
  "Manufacturer operation and maintenance manuals": "أدلة التشغيل والصيانة من الشركة المصنّعة",
  "Service intervals, spares and test procedures for installed plant. Each handover should add its own; the Projects conformity checklist asks for them.":
    "فترات الخدمة وقطع الغيار وإجراءات الاختبار للمعدات المركّبة. يجب أن يضيف كل تسليم أدلته؛ وقائمة التحقق من المطابقة في المشاريع تطلبها.",
  "Engineering · Projects · Logistics": "الهندسة · المشاريع · اللوجستيات",
  "Assessing and reporting the condition of paved surfaces, the runway condition assessment matrix, and the format field condition reports take.":
    "تقييم حالة الأسطح المرصوفة والإبلاغ عنها، ومصفوفة تقييم حالة المدرج، وصيغة تقارير حالة الجانب الجوي.",
  "Inspections · Friction · Safety critical": "الفحوص · الاحتكاك · حرج للسلامة",
  "Land uses, water, and vegetation that attract hazardous wildlife, and the separation distances and management expected of the operator. The instrument behind vegetation control on and beside the movement area.":
    "استخدامات الأراضي والمياه والنباتات التي تجذب الحياة الفطرية الخطرة، ومسافات الفصل والإدارة المتوقعة من المشغّل. الأداة التنظيمية وراء مكافحة النباتات في منطقة الحركة وحولها.",
  "Inspections · Safety critical · Sustainability": "الفحوص · حرج للسلامة · الاستدامة",
  "Operations · Compliance · Projects": "العمليات · الامتثال · المشاريع",
  "How airside vehicles must be painted, marked and lit to be seen from the tower and from an aircraft.":
    "كيف يجب طلاء مركبات الجانب الجوي وتعليمها وإنارتها لتُرى من البرج ومن الطائرة.",
  "Operations · Safety critical": "العمليات · حرج للسلامة",
  "Driver training, movement area access, radio discipline and escort — the instrument behind requiring tower clearance before a vehicle enters a runway.":
    "تدريب السائقين والدخول إلى منطقة الحركة وانضباط الاتصال اللاسلكي والمرافقة — الأداة التنظيمية وراء اشتراط تصريح البرج قبل دخول مركبة إلى المدرج.",
  "Operations · Safety critical · Inspections": "العمليات · حرج للسلامة · الفحوص",
  "Pavements · Engineering · Assessments": "الرصف · الهندسة · التقييمات",
  "How pavement strength is computed and published for the AIP. Note that the method moved from ACN-PCN to ACR-PCR — confirm which edition your State has adopted before publishing a figure.":
    "كيف تُحسب قوة الرصف وتُنشر في AIP. لاحظ أن الطريقة تغيّرت من ACN-PCN إلى ACR-PCR — تأكد من الإصدار الذي اعتمدته دولتك قبل نشر أي رقم.",
};
export default ar;
